import React, { useRef, useState } from 'react';
import { Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { BetaSchemaForm, ProFormColumnsType, ProFormInstance } from '@ant-design/pro-components';
import { Captcha } from '../Captcha';
import logoIcon from './img/logo.svg';
import bodyBg from './img/body-bg.svg';
import emailIcon from './img/email.svg';
import passwordIcon from './img/password.svg';

export interface LoginProps {
    onSubmit: (values: { email: string; password: string; id: string, distance: number }) => Promise<void> | void;
    getCaptcha: (params: any) => Promise<any>;
    // lang?: string[];
    title: string;
    titleIcon: any;
    topRight?: React.ComponentType<any>;
    bottomLeft?: React.ComponentType<any>;
    bottomRight?: React.ComponentType<any>;
    [key: string]: any;
}

export const Login: React.FC<LoginProps> = (props) => {
    const TopRight = props.topRight
    const BottomLeft = props.bottomLeft
    const BottomRight = props.bottomRight
    const formRef = useRef<ProFormInstance>(null);
    const captchaRef = useRef<{ open: (params: any) => void }>(null);

    // 表单配置 - JSON格式
    const formColumns: ProFormColumnsType[] = [
        {
            title: '邮箱地址',
            dataIndex: 'email',
            valueType: 'text',
            formItemProps: {
                rules: [
                    { required: true, message: '请输入邮箱地址' },
                    {
                        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: '请输入正确的邮箱格式'
                    }
                ],
                className: '!mb-[16px] [&_.ant-form-item-label>label]:text-[#111] [&_.ant-form-item-label>label]:text-[14px] [&_.ant-form-item-label>label]:font-medium [&_.ant-form-item-label>label]:leading-[20px] [&_.ant-form-item-label]:pb-[4px]'
            },
            fieldProps: {
                placeholder: '请输入',
                prefix: <img src={emailIcon} className='w-[20px] h-[20px]'></img>,
                className: 'h-[36px] rounded-lg border border-[#EEE] bg-white px-[10px] [&_input]:placeholder:text-[#929292] [&_input]:placeholder:text-[14px] [&_input]:placeholder:leading-[20px]',
                onPressEnter: () => formRef.current?.submit()
            }
        },
        {
            title: '密码',
            dataIndex: 'password',
            valueType: 'password',
            formItemProps: {
                rules: [
                    { required: true, message: '请输入密码' }
                ],
                className: '[&_.ant-form-item-label>label]:text-[#111] [&_.ant-form-item-label>label]:text-[14px] [&_.ant-form-item-label>label]:font-medium [&_.ant-form-item-label>label]:leading-[20px] [&_.ant-form-item-label]:pb-[4px]'
            },
            fieldProps: {
                placeholder: '请输入',
                prefix: <img src={passwordIcon} className='w-[20px] h-[20px]'></img>,
                className: 'h-[36px] rounded-lg border border-[#EEE] bg-white px-[10px] [&_input]:placeholder:text-[#929292] [&_input]:placeholder:text-[14px] [&_input]:placeholder:leading-[20px]',
                onPressEnter: () => formRef.current?.submit()
            }
        }
    ];
    const [formData, setFormData] = useState<{ email: string; password: string }>({ email: '', password: '' });

    // 表单提交
    const handleSubmit = async ({ id, distance }: { id: string, distance: number }) => {
        await props.onSubmit({ ...formData, id, distance });
    };

    // 表单验证成功，打开验证码
    const handleFormFinish = (values: { email: string; password: string }) => {
        setFormData(values);
        captchaRef.current?.open(values);
    };

    return <div className='w-screen h-screen flex flex-col justify-between items-center bg-center bg-cover bg-no-repeat overflow-hidden'
        style={{ backgroundImage: `url(${bodyBg})` }}>
        <div className='w-full h-[80px] px-[24px] flex justify-between items-center'>
            <img className='h-[36px] object-contain' src={logoIcon}></img>
            <div className='h-full'>{TopRight && <TopRight></TopRight>}</div>
        </div>
        <div className='w-[348px] flex flex-col p-[24px] rounded-[16px] border border-solid border-[#E4EBF1] bg-white shadow-[0_12px_24px_-6px_rgba(14,19,26,0.12)]'>
            <div className='flex flex-col items-center justify-between text-[16px] text-[#111] leading-[24px] font-semibold'>
                <img src={props?.titleIcon} className='w-[64px] h-[64px] mb-[8px]'></img>
                {props?.title}
            </div>
            <div className='w-full h-[1px] my-[24px] bg-[#EEE]'></div>
            <BetaSchemaForm
                formRef={formRef}
                layoutType='Form'
                columns={formColumns}
                submitter={false}
                onFinish={handleFormFinish}
                requiredMark={false}
            />

            <Button
                type="primary"
                onClick={() => formRef.current?.submit()}
                className='w-full h-[36px] text-white text-[14px] font-medium leading-[20px] rounded-[8px] border border-[rgba(0,0,0,0.10)] bg-[linear-gradient(180deg,#71B2FF_0%,#0077FD_100%)] shadow-[0_1px_2px_0_rgba(14,19,26,0.08)]'
            >
                登录
            </Button>

            <Captcha
                ref={captchaRef}
                getCaptcha={props.getCaptcha}
                onSubmit={handleSubmit}
            />
        </div>
        <div className='w-full h-[56px]'>
            <div className='h-full'>{BottomLeft && <BottomLeft></BottomLeft>}</div>
            <div className='h-full'>{BottomRight && <BottomRight></BottomRight>}</div>
        </div>
    </div>
};

